<template>
  <div :class="['com-point', 'com-point__' + types]" />
</template>

<script>
export default {
  props: {
    type: {
      type: [String, Number],
      default: 0
    }
  },
  computed: {
    types() { // required: 门槛项, mapping: 匹配项, veto: 否决项, bonus: 加分项
      switch (+this.type) {
        case 1:
          return 'required';
        case 2:
          return 'mapping';
        case 3:
          return 'veto';
        case 4:
          return 'bonus';
        default:
          return '';
      }
    }
  }
};
</script>

<style lang="scss" scoped>
  .com-point {
    width: 6px;
    height: 6px;
    border-radius: 1px;

    &__required {
      background: #fa8c16;
    }

    &__mapping {
      background: #52c41a;
    }

    &__veto {
      background: #f5222d;
    }

    &__bonus {
      background: #36cfc9;
    }
  }
</style>
